import { Button } from '@trackman/web-shared-components';
import React from 'react';
import styled from 'styled-components';
import { black, darkgrey, white } from 'styles/Colors';

export const Container = styled.div`
  display: inline-flex;
  flex-direction: column;
  width: 50%;
  align-items: left;
`;

export const LineupSelectors = styled.div`
  margin-bottom: 90px;
  display: flex;
  justify-content: space-between;

  .left-side,
  .right-side {
    display: inline-flex;
    flex-direction: column;
    width: calc(50% - 16px);
    align-items: left;
    background-color: ${white};
    padding: 0 8px 8px;

    .title {
      font-family: Oswald;
      font-size: 11px;
      font-weight: 500;
      line-height: 2.18;
      letter-spacing: 0.25px;
      color: ${black};
      text-transform: uppercase;
    }
  }
`;

export const Title = styled.div`
  color: #414141;
  font-family: Oswald;
  font-size: 22px;
  font-style: normal;
  font-weight: 500;
  line-height: 30.8px;
  letter-spacing: 0.7px;
  text-transform: uppercase;
`;

export const TitleWrapper = styled.div`
  display: flex;
  gap: 16px;
`;

export const StyledSwitchButton = styled((props) => <Button {...props} />)`
  &&& {
    color: ${darkgrey};
    background-color: #f5f5f5;
  }
`;

export const SetLineupWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 19px;
`;
